angular.module('app')
.filter("toNumber", function () {
    return (input) => parseInt(input);
})
.filter("formatGoogleDate", () => {
    return (input) => input.substr(6,2) + '/' + input.substr(4,2) + '/' + input.substr(0,4) + ' ' + input.substr(8,2) + ':' + input.substr(10,2)
})
